<template lang="pug">
.lobster-page
    .hero
        h1 给你的宝宝养一只龙虾吧
        p.subtitle 陪伴他健康成长

    .features
        .feature-card
            .feature-icon 💬
            .feature-text
                .feature-title 24小时即时解答
                .feature-desc 随时解答育儿疑问，不用排队等医生
        .feature-card
            .feature-icon 📊
            .feature-text
                .feature-title 记录宝宝数据
                .feature-desc 喂养、体重、睡眠，说一句话就记下
        .feature-card
            .feature-icon 🚨
            .feature-text
                .feature-title 识别危险信号
                .feature-desc 发现异常及时提醒，守护宝宝安全
        .feature-card
            .feature-icon 👩‍⚕️
            .feature-text
                .feature-title 连接专业照护师
                .feature-desc 复杂问题一键转接真人照护师跟进

    .demo
        h2 使用示例
        p.demo-desc 半夜宝宝哭闹不停？随时语音提问，小龙虾秒回实用建议
        .img-wrap
            img.demo-img(:src="demoChatImg")

    .method
        h2 方式一：扫码进入
        p.method-desc 截图保存下方小程序码，微信扫一扫识别
        .img-wrap
            img.qrcode(:src="qrcodeImg")
        p.method-desc 进入后点击首页大图即可开始
        .img-wrap
            img.screenshot(:src="homepageImg")

    .method
        h2 方式二：微信搜索
        p.method-desc 打开微信，搜索以下小程序名称
        .search-name
            span.name 袋鼠照护助手
            span.copy-btn(
                v-clipboard:copy="'袋鼠照护助手'"
                v-clipboard:success="onCopySuccess"
            ) 一键复制
        .img-wrap
            img.screenshot(:src="searchImg")
</template>

<script>
import { Toast } from 'vant';
import qrcodeImg from '@/assets/lobster/qrcode.png';
import homepageImg from '@/assets/lobster/homepage.png';
import searchImg from '@/assets/lobster/search.png';
import demoChatImg from '@/assets/lobster/demo-chat.jpg';

export default {
    name: 'Lobster',
    data () {
        return {
            qrcodeImg,
            homepageImg,
            searchImg,
            demoChatImg
        };
    },
    methods: {
        onCopySuccess () {
            Toast.success('已复制，去微信搜索吧');
        }
    }
};
</script>

<style lang="sass" scoped>
.lobster-page
    width: 100%
    min-height: 100vh
    background: linear-gradient(180deg, #FFF5F0 0%, #FFFFFF 40%)
    padding-bottom: .8rem

.hero
    text-align: center
    padding: .8rem .4rem .5rem
    h1
        font-size: .48rem
        font-weight: 700
        color: #E8593C
        margin-bottom: .16rem
    .subtitle
        font-size: .3rem
        color: #999

.features
    padding: 0 .32rem
    .feature-card
        display: flex
        align-items: center
        background: #fff
        border-radius: .16rem
        padding: .28rem .32rem
        margin-bottom: .2rem
        box-shadow: 0 .04rem .16rem rgba(0, 0, 0, 0.05)
        .feature-icon
            font-size: .56rem
            margin-right: .24rem
            flex-shrink: 0
        .feature-text
            .feature-title
                font-size: .3rem
                font-weight: 600
                color: #333
                margin-bottom: .06rem
            .feature-desc
                font-size: .24rem
                color: #999

.demo
    padding: .5rem .32rem 0
    h2
        font-size: .36rem
        font-weight: 600
        color: #333
        margin-bottom: .2rem
    .demo-desc
        font-size: .28rem
        color: #666
        margin-bottom: .24rem
    .img-wrap
        text-align: center
        margin-bottom: .32rem
        .demo-img
            width: 70%
            border-radius: .24rem
            box-shadow: 0 .04rem .2rem rgba(0, 0, 0, 0.1)
            margin: 0 auto

.method
    padding: .5rem .32rem 0
    h2
        font-size: .36rem
        font-weight: 600
        color: #333
        margin-bottom: .2rem
    .method-desc
        font-size: .28rem
        color: #666
        margin-bottom: .24rem
    .img-wrap
        text-align: center
        margin-bottom: .32rem
        .qrcode
            width: 4rem
            height: 4rem
            margin: 0 auto
        .screenshot
            width: 100%
            border-radius: .16rem
            box-shadow: 0 .04rem .2rem rgba(0, 0, 0, 0.08)

.search-name
    display: flex
    align-items: center
    justify-content: space-between
    background: #FFF5F0
    border-radius: .12rem
    padding: .24rem .32rem
    margin-bottom: .32rem
    .name
        font-size: .32rem
        font-weight: 600
        color: #E8593C
    .copy-btn
        font-size: .26rem
        color: #fff
        background: #E8593C
        border-radius: .32rem
        padding: .1rem .28rem
        white-space: nowrap
</style>
